import {Stack} from '@mui/material';
import styled from 'styled-components';

export const Container = styled(Stack)`
	background-color: ${({theme}) => theme.colors.gray['05Percent']};
	padding-top: 8px;
	padding-bottom: 16px;
	padding-right: 16px;
	border-top: 1px solid ${({theme}) => theme.colors.gray['20Percent']};
	align-items: flex-end;
`;

export const WrapperButtons = styled(Stack)`
	flex-direction: row;
	gap: 4px;
`;
